import IndexPage from "../Components/IndexPage";

function Index() {
    // pass boolean to populate with data or just empty calendar???
    return (
        <IndexPage />
    );
}

export default Index;